export default __webpack_public_path__ + "static/media/calendar.3e65a17f.svg";